import React from 'react'

import {SmallHelp} from '@components/common/help/help'
import {LangType} from 'yougile-lang'

interface ProjectGroupTitleProps {
  title: string
  count: number
  help?: keyof LangType['help']
}

export const ProjectGroupTitle = ({
  title,
  count,
  help
}: ProjectGroupTitleProps) => (
  <>
    <div className="flex-none mr-4">
      {title} ({count})
    </div>
    {help && <SmallHelp name={help} />}
  </>
)
